import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import Home from '../pages/Home/home';
import Home2 from '../pages/Home/home2';
import Home3 from '../pages/Home/home3';
import Detail from '../pages/CertificationDetail/detail';
// import { useSelector } from 'react-redux';

// const PrivateRoute = ({ element }) => {
//   const token = useSelector((state) => state.auth.token);
//   return token ? element : <Navigate to="/login" />;
// };

const AppRoutes = () => (
  <Router>
    <Routes>
      {/* <Route path="/login" element={<Login />} /> */}
      {/* <Route path="/home" element={<PrivateRoute element={<Home />} />} /> */}
      <Route path="/home" element={<Home />} />
      <Route path="/home2" element={<Home2 />} />
      <Route path="/home3" element={<Home3 />} />
      <Route path="/detail" element={<Detail />} />
      <Route path="/" element={<Navigate to="/home" />} />
    </Routes>
  </Router>
);

export default AppRoutes;
